export default __webpack_public_path__ + "static/media/1351.22061318.png";